<template>
  <gj-modal v-bind="$attrs" v-on="$listeners" :visible.sync="modalVisible" size="700XAuto"
    :content-style="{ 'height': '100%', 'width': '500px', 'display': 'flex', 'flex-direction': 'column' }"
    :confirm-loading="loading"
    @cancel="cancel"
    @confirm="confirm"
    >
    <template #header>编辑邮箱</template>
    <template #content>
      <el-form ref="form" :model="form" size="small" label-width="100px" autocomplete="off">
        <el-form-item label="邮箱类型"  :rules="[
              { required: true, message: '请选择邮件类型', trigger: ['change'] }
            ]">
          <gj-select disabled v-model="emailType" width="480px" :options="MarketEnum.emailOption" placeholder="请选则邮箱类型" :clearable="false"></gj-select>
        </el-form-item>
        <el-form-item prop="account" label="邮箱账号" style="margin-top: 5px;margin-bottom: 14px"  :rules="[
              { required: true, message: '请输入邮箱账号', trigger: ['change'] }
            ]">
          <gj-input @input="inputAccount" v-model="form.account" width="480px" placeholder="亚马逊后台授权服务邮箱账号" disabled>
<!--            企业邮箱、手动填写时，没有默认邮箱后缀-->
            <template #append v-if="!['exmail.qq', 'qiye.163', 'qiye.aliyun', 'outlook', 'noMail'].includes(emailType)">
              {{emailTypeInfo.append}}
            </template>
          </gj-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 14px" prop="authCode" :label="emailTypeInfo.type === 'code'?'授权码':emailTypeInfo.type === 'passWord'?'密码':'密码/授权码'">
            <gj-input
                v-model="form.authCode"
                width="480px"
                :placeholder="emailTypeInfo.type === 'code'?'邮箱授权码非邮箱登录密码':emailTypeInfo.type === 'passWord'?'请输入密码':'根据邮箱要求，密码/授权码二选一填写'"
               >
            </gj-input>
            <div class="form-item-info colorRed" v-if="emailTypeInfo.id === 'Hotmail'">提示：Hotmail邮箱非授权码授权，会出现授权成功后又失败的情况，需要重新在邮箱授权中再次授权</div>
            <template v-else>
                <div class="form-item-info">查看教程
                    <a href="http://help.gerpgo.com/web/#/26?page_id=639" target="_blank">《如何获取邮箱授权码》</a>
                </div>

                <el-form-item style="margin-bottom: 2px;" v-if="emailTypeInfo.id === '126' || emailTypeInfo.id === '163'">
                    <gj-required style="margin-right: 10px">额外验证</gj-required>
                    <span>126，163邮箱需要额外验证，请<gj-button @click="hrefValidMail" style="padding: 0" type="text">点此链接</gj-button>进行验证</span>
                </el-form-item>
            </template>
        </el-form-item>
        <!-- <el-form-item label="授权码" prop="authCode" style="width: 600px;"  :rules="[
              { required: true, message: '请输入授权码', trigger: ['change'] }
            ]">
          <el-input v-model="form.authCode" placeholder="邮箱授权码非邮箱登录密码" style="width: 250px;margin-right:20px;"></el-input>
          <span>查看教程<a href="http://help.gerpgo.com/web/#/26?page_id=639" target="_blank">《如何获取邮箱授权码》</a></span>
        </el-form-item> -->
        <div style="display: flex;margin-bottom: 14px">
          <el-form-item style="margin-bottom: 0" prop="imapServer" label="IMAP服务器">
            <gj-input v-model="form.imapServer" width="250px" placeholder="邮箱服务器，在邮箱设置中可获取" disabled></gj-input>
          </el-form-item>
          <gj-checkbox @change="changeSSL" v-model="form.imapSsl" style="margin-left: 10px; padding-top: 6px; margin-right: 10px">
            {{emailType === 'outlook'?'TLS':'SSL'}}
          </gj-checkbox>
          <gj-input width="150px" v-model="form.imapPort"></gj-input>
        </div>
        <el-form-item label="权限管理" prop="activeValue" style="width: 600px;">
          <el-switch v-model="form.activeValue" active-color="#1F6EEF" inactive-color="#E4E5E6">
          </el-switch>
          <span style="margin-left: 15px;">开启</span>
          <span>（默认超级管理员，平台管理员及新增用户拥有此邮箱权限）</span>
        </el-form-item>
        <el-form-item  prop="checkUser" style="width: 600px;" v-if="form.activeValue">
         <el-transfer
                style="text-align: left;justify-content: center;"
                v-model="checkUserList"
                filterable
                :titles="['未选用户', '已选用户']"
                :format="{
                    noChecked: '${total}',
                    hasChecked: '${checked}/${total}'
                }"
                :data="userList">
            </el-transfer>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, queryMixin, formRuleMixin, responseMixin} from "../../../../../minxins";
import {MarketEnum} from "@/views/modules/system/market/enum";
import {isMeaningful, isMeaningless, transformToMap} from "@/utils/common";
import { findAll } from '../../../../../api/setting';
import { updateOutEmail} from '../../../../../api/crm';
import { el } from 'date-fns/locale';

export default {
  name: "edit-mailbox",
  mixins: [modalMixIn, queryMixin, formRuleMixin, responseMixin],
  props: {
    item:null
  },
  data() {
    const generateData = _ => {
      const data = [];
      for (let i = 1; i <= 15; i++) {
        data.push({
          key: i,
          label: `备选项 ${i}`,
          disabled: i % 4 === 0
        });
      }
      return data;
    };
    return {
      loading: false,
      MarketEnum,
      emailType:'qq',//邮箱类型 用于快速填充IMAP、SSL等
      opType: null,
      userList: [],
      checkUserList: [],
      form: {
        account: null,
        authCode: null,
        marketIds: [],
        imapServer: "imap.qq.com",
        imapPort: '993',
        imapSsl: true,
        selectAccount: null,
        activeValue: true
      },
      transfer: [1, 4],
      tdata: generateData(),
    }
  },
  computed: {
    validateRules({ form, rules1, rules2 }) {
      return form.type === 0 ? rules1 : rules2
    },
    // 选中邮件类型 的 相关信息
    emailTypeInfo(){
      return MarketEnum.emailOption.find(r => r.id === this.emailType);
    },
    authCodeRuleStr(){
      return this.emailTypeInfo.type === 'code'?'请输入授权码':this.emailTypeInfo.type === 'passWord'?'请输入密码':'请输入密码/授权码'
    },
  },
  watch:{
    // 选中邮件类型变化时
    emailType:{
      handler(val){
        // 勾选SSL
        this.form.imapSsl = true;
        // 设置SSL
        if(this.emailType === 'outlook'){
          this.form.imapPort = this.emailTypeInfo.TLS;
        }else {
          this.form.imapPort = this.emailTypeInfo.SSL;
        }
        // 设置IMAP服务器
        this.form.imapServer = this.emailTypeInfo.IMAP[0];
        this.$nextTick(()=>{
          this.$refs.form.clearValidate('authCode');
          this.$refs.form.clearValidate('imapServer');
        })

      }
    },
    immediate:true
  },
  methods: {
    changeType() {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
   
    // SSL勾选状态变化时
    changeSSL(event) {
      if(this.emailType === 'outlook'){
        this.form.imapPort = event ? this.emailTypeInfo.TLS : '143';
      }else {
        this.form.imapPort = event ? this.emailTypeInfo.SSL : '143';
      }

    },
    hrefValidMail() {
      if (isMeaningful(this.form.account)) {
        window.open(`http://config.mail.163.com/settings/imap/login.jsp?uid=${this.form.account + this.emailTypeInfo.append}`,"_blank");
      } else {
        this.$gjMessage.warning('请先输入邮箱账号')
      }
    },
    inputAccount() {
 
    },
    confirm(fn) {
      if (this.$gjFormValidate()) {
        this.loading = true;
        var userCheckSet = new Set(this.checkUserList);
        const params = {
          id: this.item.emailId,
          account: this.form.account+this.emailTypeInfo.append,
          authCode: this.form.authCode,
          imapPort: this.form.imapPort,
          imapServer: this.form.imapServer,
          imapSsl: this.form.imapSsl,
          status: this.item.status,
          userIds: this.form.activeValue == true ? userCheckSet : new Set()
        }
        updateOutEmail(params).then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success("操作成功");
                this.$emit("after");
              });
            })
            .complete(() => (this.loading = false));
      }
    },
    transitionObj(data){
        const list = [];
        if(data === null || data.length == 0){
          return list;
        }
        for (var i=0;i<data.length;i++){
          list.push({
            key: data[i].id,
            label: data[i].name,
          })
        }
        return list;
      },
      //筛选出邮箱类型
      getEmailTypeID(imapStr) {
         let info = MarketEnum.emailOption.find(r => r.IMAP[0] === imapStr);
         if (info !== undefined && info.id !== undefined) {
             this.emailType = info.id;
         } else {
             this.emailType = "qq";
         }
      }


  },
  created(){
    //查询出所有用户
    findAll().then(response => {
        this.userList = this.transitionObj(response.data)
    });
    this.getEmailTypeID(this.item.imapServer);
    this.form = {
        account: this.item.account,
        authCode: this.item.authCode,
        imapServer: this.item.imapServer,
        imapPort: this.item.imapPort,
        imapSsl: this.item.imapSsl == 1 ? true : false,
        activeValue: false,
    };
    if (this.form.account.indexOf(this.emailTypeInfo.append) != -1) {
      let index = this.form.account.indexOf(this.emailTypeInfo.append)
      this.form.account = this.form.account.substring(0, index)
    }
    if (this.item !== null && this.item.userIds != undefined) {
        var checks = this.item.userIds ?? {};
        this.checkUserList = Array.from(checks);
        this.form.activeValue = true;
    }
},
}
</script>

<style lang="scss" scoped>
.el-col-ssl {
  .el-checkbox {
    margin-left: 15px;
  }

  .el-checkbox,
  .el-form-item {
    display: inline-block;
  }

  .el-form-item {
    width: 221px;
  }
}
</style>
